import { render, staticRenderFns } from "./PageKioskDevices.vue?vue&type=template&id=91289b46&"
import script from "./PageKioskDevices.vue?vue&type=script&lang=js&"
export * from "./PageKioskDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91289b46')) {
      api.createRecord('91289b46', component.options)
    } else {
      api.reload('91289b46', component.options)
    }
    module.hot.accept("./PageKioskDevices.vue?vue&type=template&id=91289b46&", function () {
      api.rerender('91289b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/kiosk-devices/PageKioskDevices.vue"
export default component.exports